import React from 'react'
import { Card } from 'antd'
import { connect } from 'react-redux'
import Capture from './LayoutComponents/Capture'
import Download from './LayoutComponents/Download'
// import Overlay from './LayoutComponents/Overlay'
import Showcase from './LayoutComponents/Showcase'
// import Sticker from './LayoutComponents/Sticker'
import './booth.less'

const steps = [
  <Capture />,
  <Showcase />,
  // <Overlay />,
  // <Sticker />,
  <Download />,
]

const mapStateToProps = ({ photobooth }) => ({ photobooth })
@connect(mapStateToProps)
class Booth extends React.Component {
  render() {
    const {
      photobooth: { currentStep },
    } = this.props
    return (
      <div className="photobooth text-center">
        <Card bordered={false} className="boothDesign">{steps[currentStep]}</Card>
      </div>
    )
  }
}

export default Booth
